export const ContactType = {
  Candidate: 1,
  Client: 2,
  Lead: 3
};

export const SurveyCustomFieldType = {
  List: "List",
  Text: "Text",
  Date: "Date"
};

export const OptionSalaryRate = [
  {
    value: "Hour",
    text: "Hourly Rate"
  },
  {
    value: "Day",
    text: "Daily Rate"
  },
  {
    value: "Week",
    text: "Weekly Rate"
  },
  {
    value: "Month",
    text: "Monthly Rate"
  },
  {
    value: "Year",
    text: "Yearly Rate"
  },
];

// JobAdder's SubmitCandidateAvailabilityModel.Relative accepts a free-form
// Period (int) + a fixed Week/Month Unit — there's no lookup endpoint for
// this, so these presets mirror JobAdder's own candidate availability
// picker. Value encodes "{period}-{unit}" for BE-side parsing.
export const OptionNoticePeriod = [
  { value: "1-Week", text: "1 Week" },
  { value: "2-Week", text: "2 Weeks" },
  { value: "3-Week", text: "3 Weeks" },
  { value: "4-Week", text: "4 Weeks" },
  { value: "1-Month", text: "1 Month" },
  { value: "2-Month", text: "2 Months" },
  { value: "3-Month", text: "3 Months" },
  { value: "6-Month", text: "6 Months" },
];

export const AtsSyncVendor = {
  JobAdder: 1
};

export const SurveyStateType = {
  Active: 1,
  Inactive: 2
};

export const SurveyFormFace = {
  Autoscroll: "autoscroll",
  Chat: "chat",
  Classic: "classic"
};
